export default class Recherche {
  constructor () {
    console.log('recherche constructor')
    this.$form = $('.wp-block-recherche-form')
    this.$input = $('.navigation-search-input .search-input')
    // this.$inputMobile = $('.wp-block-recherche-input-mobile')
    this.$submit = $('.wp-block-recherche-submit')
    this.$remove = $('.navigation-search-wrapper .search-form-close')
    this.$searchWrapper = $('.navigation-search-wrapper')
    this.$btnSearchSpan = $('.navigation-principale-item .btn-search span, .banner-mobile-search span')
    this.init()
  }

  init () {
    // console.log('recherche init')
    this.updateRemoveVisibility()

    this.$input.each((index, input) => {
      const $input = $(input)
      $input.on('input', event => {
        this.updateRemoveVisibility(event)
      })
      this.addEscapeKeyListener($input)
    })

    this.$remove.click(() => {
      this.updateRemoveVisibility()
    })

    if ($('.wp-block-recherche').length) {
      // this.$submit.click
      this.handleBreakpointMobile()
      this.handleSubmit()
    }
  }

  updateRemoveVisibility (event) {
    // console.log('val:', this.$input.val(), this.$remove)
    const $input = event ? $(event.currentTarget) : this.$input
    if ($input.val() !== '') {
      this.$remove.show()
    } else {
      this.$remove.hide()
    }
  }

  handleSubmit () {
    this.$submit.click(() => {
      this.$form.submit()
    })
  }

  updateInputSearchPlaceholder (e) {
    if (e.matches) {
      // console.log(this.$input.attr('data-placeholder-mobile'))
      this.$input.attr('placeholder', this.$input.attr('data-placeholder-mobile'))
    } else {
      // console.log(this.$input.attr('data-placeholder'))
      this.$input.attr('placeholder', this.$input.attr('data-placeholder'))
    }
  }

  handleBreakpointMobile () {
    const mql = window.matchMedia('(max-width: 1023px)')
    this.updateInputSearchPlaceholder(mql)
    mql.addEventListener('change', (e) => {
      this.updateInputSearchPlaceholder(e)
    })
  }

  addEscapeKeyListener ($input) {
    $input.on('keydown', event => {
      if (event.key === 'Escape') {
        this.handleEscapeKey($input)
      }
    })
  }

  handleEscapeKey ($input) {
    $input.blur()
    this.$searchWrapper.slideToggle()
    $input.val('')
    this.$btnSearchSpan.toggleClass('hidden')
  }
}
